import React from 'react';
import { Box, Typography } from '@mui/material';
import TaskingStripThumbnail from './TaskingStripThumbnail';
import CalendarIcon from '../icons/CalendarIcon';
import SunElevationIcon from '../icons/SunElevationIcon';
import OffNadirIcon from '../icons/OffNadirIcon';
import CoverageIcon from '../icons/CoverageIcon';

const formatDisplayDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  try {
    const date = new Date(timestamp.replace(' ', 'T'));
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    };
    return date.toLocaleDateString('en-GB', options).toUpperCase();
  } catch (err) {
    // Fallback: try to extract just the date part
    const datePart = timestamp.split(' ')[0];
    if (datePart) {
      try {
        const date = new Date(datePart);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase();
      } catch {
        return datePart;
      }
    }
    return timestamp;
  }
};

const TaskingStripCard = ({ strip, isSelected, onSelect }) => {
  return (
    <Box
      onClick={(event) => {
        event.stopPropagation();
        onSelect?.(strip);
      }}
      sx={{
        bgcolor: isSelected ? '#7C7C7C66' : 'transparent',
        border: isSelected ? '1px solid #76b6ff' : '1px solid transparent',
        borderRadius: 1,
        overflow: 'hidden',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
        px: 0.25,
        py: 0.5,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        position: 'relative',
        '&:hover': {
          bgcolor: isSelected ? '#7C7C7C66' : 'rgba(124, 124, 124, 0.2)',
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <TaskingStripThumbnail coordinates={strip.coordinates} color={strip.color} />
      </Box>
      <Box sx={{ fontSize: '10px', color: 'rgba(255, 255, 255, 0.7)', flex: 1, minWidth: 0 }}>
        {/* Date */}
        <Typography sx={{ fontSize: 'inherit', mb: 0, display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>
          <Box sx={{ flexShrink: 0 }}>
            <CalendarIcon size={10} color="rgba(255, 255, 255, 0.7)" />
          </Box>
          <Box sx={{ whiteSpace: 'nowrap' }}>
            {formatDisplayDate(strip.access_start)}
          </Box>
        </Typography>
        {/* Coverage */}
        {strip.coverage != null && !Number.isNaN(Number(strip.coverage)) && (
          <Typography sx={{ fontSize: 'inherit', mb: 0, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CoverageIcon size={10} color="rgba(255, 255, 255, 0.7)" /> {Number(strip.coverage).toFixed(1)}%
          </Typography>
        )}
        {/* Off Nadir */}
        {strip.viewingAngle != null && !Number.isNaN(Number(strip.viewingAngle)) && (
          <Typography sx={{ fontSize: 'inherit', mb: 0, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <OffNadirIcon size={10} color="rgba(255, 255, 255, 0.7)" /> {Number(strip.viewingAngle).toFixed(1)}°
          </Typography>
        )}
        {/* Sun Elevation */}
        {strip.sunElevation != null && !Number.isNaN(Number(strip.sunElevation)) && (
          <Typography sx={{ fontSize: 'inherit', mb: 0, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <SunElevationIcon size={10} color="rgba(255, 255, 255, 0.7)" /> {Number(strip.sunElevation).toFixed(1)}°
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TaskingStripCard;

